import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Method } from './components/Method';
import { Contents } from './components/Contents';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Faq } from './components/Faq';
import { LegalFooter } from './components/LegalFooter';
type AppProps = {
  ctaVariant?: 'directo' | 'urgencia' | 'emocional' | 'apremiante';
};
export function App({
  ctaVariant = 'directo'
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="2whxcnx635uha">
      <noscript data-id="element-1" data-mp="28suumo7jhzm9">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="28sl0cofgp6ar" />
      </noscript>
      <Hero data-id="element-3" data-mp="3mlj8gtrwtb2j" />
      <main data-id="element-4" data-mp="3mlatmwc87vop">
        <Problem data-id="element-5" data-mp="3mkrbpfmkt7ao" />
        <Method data-id="element-6" data-mp="3mk852v2dm5by" />
        <Contents data-id="element-7" data-mp="3mjq2lgp4euvl" />
        <Author data-id="element-8" data-mp="3mj6jvxrnc2gi" />
        <Testimonials data-id="element-9" data-mp="3rcj6k2crlz6m" />
        <Bonuses data-id="element-10" data-mp="3rbzq6q2rjiup" />
        <Offer ctaVariant={ctaVariant} data-id="element-11" data-mp="3rdkl4gszp3t3" />
        <Faq data-id="element-12" data-mp="5yk6vxnnffx" />
      </main>
      <LegalFooter data-id="element-13" data-mp="6htxpd5ixiv" />
    </div>;
}